import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'payment-intent-summary',
  templateUrl: './payment-intent-summary.component.html',
  styleUrls: ['./payment-intent-summary.component.scss']
})
export class PaymentIntentSummaryComponent {
  @Input() paymentIntent: any;
  @Input() currency: any;
}
